import type { ReactNode } from "react";
import { I18nProvider } from "react-aria-components";

// Picker format follows the browser/OS locale, not the selected UI language (app-wide convention; see OL-30).
export const ReactAriaI18nProvider = ({ children }: { children: ReactNode }) => (
  <I18nProvider locale={navigator.language || "en-GB"}>{children}</I18nProvider>
);
